import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    try {
      const user = getState().user?.currentUser;
      if (user?.id) {
        headers.set("userid", user.id);
      }
    } catch (_) {}
    return headers;
  },
});

export const adSearchApi = createApi({
  reducerPath: "adSearchApi",
  baseQuery,
  tagTypes: ["AdSearch"],
  endpoints: (builder) => ({
    search: builder.query({
      query: ({ query, limit = 50 }) => ({
        url: "/adsearch",
        method: "GET",
        params: { query, limit },
      }),
      providesTags: ["AdSearch"],
    }),
  }),
});

export const { useLazySearchQuery, useSearchQuery } = adSearchApi;
